import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
require('jquery-validation');

Snappy.Component.CWFooter = class CWFooter extends Snappy.BaseComponent {
	static get tagName() {
		return 'cw-footer';
	}
	
	constructor(element) {
		super(element);
		$('.fa-footer__newsletter__form').submit(this.openModalForm);
	}
	
	setVars() {
		this.$newsletterForm = this.$element.find('.cw-footer__newsletter__form');
	}
	
	setEventListeners() {
		this.$newsletterForm.on('submit', this.validateNewsletterForm.bind(this));
	}
	
	validateNewsletterForm(event) {
		const $emailField = this.$newsletterForm.find('input[type=email]');
		this.$newsletterForm.validate({
			rules: {
				'Email': {
					required: true,
					email: true
				}
			}
		});
		
		if ($emailField.valid()) {
			this.openNewsletterModal();
		} else {
			$emailField.focus();
		}
		
		event.preventDefault();
	}
	
	openNewsletterModal() {
		const $button = this.$newsletterForm.find('button');
		
		this.$window.trigger('modal:openModal', {
			$view: $($button.data('modal-template')),
			title: $button.data('modal-title'),
			$prevElement: $button
		});
	}
	
	openModalForm(event) {
		const emailAddress = $(this).find('input[type=email]').val();
		window.setTimeout(function() {
			new Snappy.Component.NewsletterForm('div.cw-newsletter-form').render();                        
			$('.cw-newsletter-form__form').find('input[type=email]').val(emailAddress);
		}.bind(this), 1); 
		event.preventDefault();
	}
	
	closeNewsletterModal(modal) {
		modal.closeModal();
	}
	
	render() {
		this.setVars();
		this.setEventListeners();
	}
};



// WEBPACK FOOTER //
// ./components/cw-footer/scripts/footer.js